import {
    MutationResolvers,
    BatchCreateDocumentDocument,
    BatchCreateDocumentMutation,
    GetAuctionIdDocument as auctionIdQuery,
    GetAuctionIdQuery,
    DocumentTypesDocument,
    DocumentTypesQuery,
} from '../../../../../generated/graphql'

const createDocumentsClient: MutationResolvers['createDocumentsClient'] = async (
    _root,
    { docs },
    { cache, client },
) => {
    if (!client) {
        throw new Error('Missing ApolloClient')
    }

    const cacheData = cache.readQuery<GetAuctionIdQuery>({
        query: auctionIdQuery,
    })
    const auctionId = cacheData?.activeOrganization?.orgId

    if (!auctionId) {
        throw new Error('Missing AuctionId')
    }

    const { data: docTypesData } = await client.query<DocumentTypesQuery>({
        query: DocumentTypesDocument,
    })

    const docTypes = docTypesData.documentTypes || []

    const updatedDocs = docs.map((d) => {
        const { docTypeId, docTypeName, displayOrder } =
            docTypes.find((dt) => d.docTypeShortCode === dt?.shortCode) || {}

        const attachment = JSON.stringify({ dir: d.s3Key })

        return {
            tenantId: auctionId,
            transactionId: d.assetId,
            docId: d.fileName,
            customerId: d.customerId,
            attachment,
            docTypeId,
            docTypeName,
            displayOrder,
            stockNumber: d.stockNumber,
            docTypeShortCode: d.docTypeShortCode,
        }
    })

    const { data: batchCreateData } = await client.mutate<BatchCreateDocumentMutation>({
        mutation: BatchCreateDocumentDocument,
        variables: {
            docs: updatedDocs,
        },
        refetchQueries: ['documentList'],
    })

    const batchDocs = batchCreateData?.batchCreateDocument?.map((d) => ({ docId: d?.docId || '' }))

    if (!batchDocs) {
        throw new Error('Missing batchDocs')
    }

    return batchDocs
}

export default createDocumentsClient
